import { Drawer, Button } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement, useState } from "react";
import { EyeOutlined } from "@ant-design/icons";
import { Link, useLocation, useParams } from "react-router-dom";
import { useHistory } from "react-router";
import AddBtn from "../common/AddBtn";
import AddNeighborhood from "./AddNeighborhood";

const TopHeading = ({ total, refetch }): ReactElement => {
  const route = useHistory();
  const [visible, setVisible] = useState<boolean>(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
    refetch();
  };

  return (
    <div className="top-heading-products top-heading-content">
      <div className="container-fluid">
        <div className="row d-flex-sb mb-15">
          <div className="col-lg-6 col-md-6 no-padding">
            <div className="page-heading-content">
              <h2 className="d-flex-l wrap d-flex-nowrap d-flex-base">
                Neighborhood List{" "}
                <span className="d-flex-l ml-1">
                  {total || 0} Neighborhood(s)
                </span>
              </h2>
            </div>
          </div>
          <div className="single-button d-flex">
            <AddBtn
              onClick={() => {
                route.push("/neighborhood/add");
              }}
            /> 

            <Button
              type="primary"
              icon={<EyeOutlined />}
              size="large"
              onClick={() => route.push(`/neighborhood/details`)}
              className="ml-2"
            >
              View All
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

TopHeading.propTypes = {
  Id: PropTypes.string,
  GetStatus: PropTypes.string,
  GetPrime: PropTypes.string,
  GetFlagship: PropTypes.string,
  GetRocket: PropTypes.string,
  title: PropTypes.string,
};

export default TopHeading;
